import React from 'react';
import Helmet from 'react-helmet';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';

import { withAppStorage } from '../utils/appStorage';
import { TransitionWrapper } from '../components/TransitionWrapper';

import GenerateMetaTags from '../components/GenerateMetaTags';
import Breadcrumbs from '../components/Breadcrumbs';
import Article, { Title, Content } from '../components/Article';
import RegistrationNumberNotice from '../components/RegistrationNumberNotice';
import GuidanceNotice from '../components/GuidanceNotice';
import InstantMuation from '../components/InstantMutation';
import { Loader } from '../components/Loader';

import { dataLayer } from '../utils/window';

const FINISH_KLARNA_CHECKOUT = gql`
  mutation finishKlarnaCheckout($klarnaOrderId: String!) {
    finishKlarnaCheckout(klarnaOrderId: $klarnaOrderId) {
      id
      sumProducts
      sumShipping
      products {
        price
        name
        productIndx
        part {
          id: Indx
          name: displayName
          stockNumber: Lagernummer
          images: Bilder
        }
      }
    }
  }
`;

export default withAppStorage(function CartPage({ appStorage, klarnaOrderId }) {
  return (
    <TransitionWrapper>
      <Helmet>
        {GenerateMetaTags({
          title: 'Checkout complete!',
          description: 'Du har fullført bestillingen.'
        })}
      </Helmet>

      <Breadcrumbs breadcrumbs={null} />

      <Article>
        <Title>Checkout complete!</Title>

        <Content wide>
          <RegistrationNumberNotice />
          <Mutation mutation={FINISH_KLARNA_CHECKOUT}>
            {(finishCheckout, { data, error, loading }) => (
              <div>
                {loading && <Loader />}
                <InstantMuation
                  mutation={() => {
                    appStorage.set('cartId', null);

                    finishCheckout({
                      variables: {
                        klarnaOrderId
                      }
                    }).then(({ data, error }) => {
                      // TODO: Return products for push to dataLayer.
                      if (error) {
                        console.error(error);
                        return;
                      }

                      dataLayer.push({
                        event: 'purchase',
                        ecommerce: {
                          purchase: {
                            actionField: {
                              id: klarnaOrderId,
                              revenue: data.finishKlarnaCheckout.sumProducts,
                              shipping: data.finishKlarnaCheckout.sumShipping,
                              OrderValue:
                                data.finishKlarnaCheckout.sumProducts +
                                data.finishKlarnaCheckout.sumShipping
                            },
                            products: data.finishKlarnaCheckout.products.map(
                              product => {
                                return {
                                  price: product.price,
                                  ...product.part
                                };
                              }
                            )
                          }
                        }
                      });
                    });
                  }}
                />

                {!error &&
                  !loading && (
                    <div>
                      <h2>Takk for din bestilling!</h2>
                    </div>
                  )}
              </div>
            )}
          </Mutation>
        </Content>
      </Article>

      <GuidanceNotice />
    </TransitionWrapper>
  );
});
